// Generated by CoffeeScript 1.12.7

/*
  This module builds and returns the steps of an accept flow (v2). It does not include
  groupAccept as this is a visually separate step to this and doesn't have the same functions to it
  like not having to validate.
  @param unbuiltSteps: an array of objects containing:
    - name [String] name of the step, e.g. "accept", "customForm", "esign", "payNow"
    - additionalParams [Object] Any extra params needed for the step's construction
 */

(function () {
  var stepsMap;

  stepsMap = {
    customForm: require("AcceptFlow/CustomForm/CustomForm")["default"],
    esign: require("AcceptFlow/ESign/ESign")["default"],
    payNow: require("AcceptFlow/PayNow/PayNowForm")["default"],
    accept: require("AcceptFlow/BasicForm/BasicForm")["default"],
  };

  module.exports = function (make, unbuiltSteps, setErrorMsg, acceptData) {
    var getStep;
    getStep = function (arg) {
      var additionalParams, name, params;
      (name = arg.name), (additionalParams = arg.additionalParams);
      params = _.extend(
        {
          setErrorMsg: setErrorMsg,
          acceptData: acceptData,
        },
        additionalParams,
      );
      return make(stepsMap[name], params);
    };
    return _.map(unbuiltSteps, function (unbuiltStep) {
      return getStep(unbuiltStep);
    });
  };
}.call(this));
